"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _footColumn = _interopRequireDefault(require("../columns/foot-column"));
/**
 * Local Imports
*/

const RowWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RowWrapper",
  class: "pl-rcwksn",
  vars: {
    "rcwksn-0": [({
      col = 2
    }) => `20vw repeat(${col}, 1fr)`]
  }
});
const ColumnWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ColumnWrapper",
  class: "pl-c15i7hqt"
});

/**
 * FootRow Component.
 *
 * @param {Object} props React props
 * @param {Array} props.items Array of footer columns
 * @returns {React.ReactElement} FootRow Component
 * @public
 */

function FootRow({
  items
}) {
  return /*#__PURE__*/_react.default.createElement(RowWrapper, {
    role: "row",
    col: items?.length
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "cell",
    "aria-hidden": true
  }), items?.slice(0, 4).map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(ColumnWrapper, {
      key: idx,
      role: "cell"
    }, /*#__PURE__*/_react.default.createElement(_footColumn.default, item));
  }));
}
var _default = exports.default = FootRow;
FootRow.propTypes = {
  items: _propTypes.default.array
};